<script setup lang="ts">
import { useDisplay } from 'vuetify';
import type { V2AccountVM } from '~/composables/useRequest/requests/data-contracts';


defineOptions({
  name: 'LayoutDefault',
});

const { smAndDown } = useDisplay();
const { isMobileShell } = useMobileShell();
const { setAccountStore } = useAccountStore();
const { $i18n } = useNuxtApp();
const route = useRoute();
const account = ref<V2AccountVM>();
const showTabs = ref(false);

const isFullscreen = computed(() => route.meta.fullscreen === true);

useThemeStore();

const drawer = ref({
  drawer: !smAndDown.value,
  rail: true,
});

const syncAccount = async () => {
  if (/^account-/.test(String(route.name)) && route.query?.idAccountSearch && /^[0-9]+$/.test(route.query.idAccountSearch.toString())) {
    const { account: accountController } = useRequest();

    try {
      const { payload } = await accountController.accountControllerGetAccount(+route.query.idAccountSearch);

      account.value = payload;
      showTabs.value = true;
    } catch {
      navigateTo(`/${$i18n.locale.value}`);
    }
  }
};

await syncAccount();

setAccountStore(account.value);
</script>

<template>
  <v-app>
    <CoreNotificationQueue />

    <NuxtLoadingIndicator />

    <template v-if="isMobileShell">
      <LazyMobileAppBar />

      <v-main>
        <v-container
          :class="[
            $style['mobile-container'],
            { [$style['default-container']]: !isFullscreen, [$style['fullscreen-container']]: isFullscreen },
          ]"
          fluid
        >
          <slot />
        </v-container>
      </v-main>

      <LazyMobileBottomNav />
    </template>

    <template v-else>
      <LazyDashboardDrawer v-model="drawer" />

      <LazyDashboardAppBar
        v-model="drawer"
        :showTabs="showTabs"
      />

      <v-main>
        <v-container
          :class="{ 'px-1': smAndDown, [$style['default-container']]: !isFullscreen, [$style['fullscreen-container']]: isFullscreen }"
          fluid
        >
          <slot />
        </v-container>
      </v-main>

      <LazyDashboardFooter />
    </template>
  </v-app>
</template>

<style module lang="scss">
.default-container {
  max-width: 1600px;
}

.fullscreen-container {
  max-width: 100%;
  height: 100%;
}

.mobile-container {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
}
</style>
